// removed by extract-text-webpack-plugin
module.exports = {"container":"_2tlE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/pageplain/style.css
// module id = 416
// module chunks = 9